import { Button, DialogWrapper } from "@memorang/ui";
import { useTranslation } from "react-i18next";
import { Linking, Platform } from "react-native";
import { Dialog, Text } from "react-native-paper";
import { useAppTheme } from "../../useAppTheme";

const isWeb = Platform.OS === "web";

export const MicrophonePermissionDialog = ({
	showDialog,
	setShowDialog,
}: { showDialog: boolean; setShowDialog: () => void }) => {
	const theme = useAppTheme();
	const { t } = useTranslation();
	const handleOpenSettings = () => {
		setShowDialog();
		Linking.openSettings();
	};
	return (
		<DialogWrapper visible={showDialog} handleClose={setShowDialog}>
			<Dialog.Icon icon="microphone" />
			<Dialog.Title style={{ textAlign: "center" }}>
				{t("session.permissionDialog.title")}
			</Dialog.Title>
			<Dialog.Content>
				<Text variant="bodyMedium">
					{isWeb
						? t("session.permissionDialog.descriptionWeb")
						: t("session.permissionDialog.descriptionMobile")}
				</Text>
			</Dialog.Content>
			<Dialog.Actions>
				<Button textColor={theme.colors.primary} onPress={setShowDialog}>
					{isWeb
						? t("session.permissionDialog.ok")
						: t("session.permissionDialog.cancel")}
				</Button>
				{!isWeb && (
					<Button mode="contained" onPress={handleOpenSettings}>
						{t("session.permissionDialog.openSettings")}
					</Button>
				)}
			</Dialog.Actions>
		</DialogWrapper>
	);
};
